import { TokensHolder } from '../services';
import { setHackettAccessTokenHeaders } from './token-utils';
import { constructUrl } from './url-utils';

const REDIRECT_PATH_STORAGE_KEY = 'REDIRECT_PATH';
const ALLOWED_PROTOCOLS = ['http:', 'https:'];

// Resolves redirectUrl against the platform signOnUrl and only accepts it when it stays on the platform origin.
// Returns the relative part (pathname + search + hash) so the origin is always taken from the trusted signOnUrl.
export function getSafeRedirectPath(redirectUrl: string | null | undefined, signOnUrl: string) {
	if (!redirectUrl) {
		return null;
	}

	try {
		const signOnOrigin = new URL(signOnUrl).origin;
		const url = new URL(redirectUrl, signOnUrl);

		if (!ALLOWED_PROTOCOLS.includes(url.protocol) || url.origin !== signOnOrigin) {
			return null;
		}

		return `${url.pathname}${url.search}${url.hash}`;
	} catch (_error) {
		return null;
	}
}

export function storeRedirectPath(redirectPath: string | null) {
	if (redirectPath) {
		sessionStorage.setItem(REDIRECT_PATH_STORAGE_KEY, redirectPath);
	} else {
		sessionStorage.removeItem(REDIRECT_PATH_STORAGE_KEY);
	}
}

export function getStoredRedirectPath() {
	return sessionStorage.getItem(REDIRECT_PATH_STORAGE_KEY);
}

interface BuildPlatformRedirectUrlArgs {
	signOnUrl: string;
	tokensHolder?: TokensHolder;
	deviceKey?: string;
}

export function buildPlatformRedirectUrl({ signOnUrl, tokensHolder, deviceKey }: BuildPlatformRedirectUrlArgs) {
	const signOnOrigin = new URL(signOnUrl).origin;
	const redirectPath = getSafeRedirectPath(getStoredRedirectPath(), signOnUrl);
	const url = new URL(redirectPath ?? signOnUrl, signOnUrl);
	const searchParams = setHackettAccessTokenHeaders({
		defaultUrl: url.search,
		token: tokensHolder,
		deviceKey,
	});

	const targetUrl = constructUrl(`${signOnOrigin}${url.pathname}`, searchParams);
	return url.hash ? `${targetUrl}${url.hash}` : targetUrl;
}
